import { Lock, Mail } from 'lucide-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { login } from '../../actions/auth';
import useAuthRedirect from '../../hooks/useAuthRedirect';

const getErrorMessage = (error) => {
  if (!error) return '';
  if (error.msg) return error.msg;
  if (error.error) return error.error;
  if (Array.isArray(error.errors) && error.errors[0]?.msg) return error.errors[0].msg;
  return 'Unable to sign in. Check your credentials and try again.';
};

export default function Login() {
  const dispatch = useDispatch();
  const { isLoading, errorMessage } = useAuthRedirect('/sites', '/login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = (event) => {
    event.preventDefault();
    dispatch(login({ email, password }));
  };

  return (
    <div className="auth-page">
      <section className="auth-side">
        <div className="auth-brand">
          <img src="/nc-logo-white.svg" alt="North Commerce" />
        </div>
        <div className="auth-pitch">
          <span className="auth-eyebrow">Welcome back</span>
          <h1>Pick up where you left off.</h1>
          <p>Sign in to manage your hosted sites, publish staging to a custom domain, or spin up a new store.</p>
        </div>
      </section>

      <main className="auth-form-panel">
        <div className="auth-meta">
          New to North? <Link to="/register">Create an account</Link>
        </div>

        <div className="auth-form-wrap">
          <span className="auth-bracket">[ Sign in ]</span>
          <h2>Sign in to your workspace.</h2>
          <p>Use the email you signed up with to access your hosted sites.</p>

          <form className="auth-form-body" onSubmit={onSubmit}>
            {getErrorMessage(errorMessage) ? <div className="error-banner">{getErrorMessage(errorMessage)}</div> : null}

            <div className="form-field">
              <label htmlFor="email">Email</label>
              <div className="input-icon-wrap">
                <Mail size={16} />
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-field">
              <div className="label-split">
                <label htmlFor="password">Password</label>
                <Link to="/forgot-password">Forgot?</Link>
              </div>
              <div className="input-icon-wrap">
                <Lock size={16} />
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                />
              </div>
            </div>

            <label className="check-line">
              <input type="checkbox" defaultChecked />
              <span>Keep me signed in on this device for 30 days.</span>
            </label>

            <button className="btn btn-primary full-width" type="submit" disabled={isLoading}>
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>
            <div className="auth-legal">
              Using a legacy account? <Link to="/activate">Activate your account</Link>.
            </div>
            <div className="auth-legal">
              Trouble signing in? <a href="mailto:hello@northcommerce.com">Contact support</a>.
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
